import React from "react";
import { Oval } from "react-loader-spinner";

import { useAppDispatch, useAppSelector } from "../../../../app/hooks";
import { Customer } from "../../../../datasource/Stax/models";
import {
  getCustomersStax,
  setSelectedCustomer,
  resetCustomerSearch,
} from "../../paymentsSlice";

import "./CustomerSearch.scss";

export interface CustomerSearchProps {
  onCustomerSelect: (customer: Customer) => void;
}

export const CustomerSearch: React.FC<CustomerSearchProps> = ({
  onCustomerSelect,
}) => {
  const dispatch = useAppDispatch();

  const customers = useAppSelector((state) => state.payments.customers);
  const selectedCustomer = useAppSelector(
    (state) => state.payments.selectedCustomer
  );
  const getCustomersStaxAPI = useAppSelector(
    (state) => state.payments.getCustomersStaxAPI
  );

  const [search, setSearch] = React.useState("");
  const debounceTimeoutRef = React.useRef<NodeJS.Timeout | null>(null);

  React.useEffect(() => {
    if (debounceTimeoutRef.current) {
      clearTimeout(debounceTimeoutRef.current);
    }

    debounceTimeoutRef.current = setTimeout(() => {
      if (search.length > 0) {
        dispatch(getCustomersStax({ search }));
      }
    }, 500);

    return () => {
      if (debounceTimeoutRef.current) {
        clearTimeout(debounceTimeoutRef.current);
      }
    };
  }, [search, dispatch]);

  const handleCustomerSelect = (customer: Customer) => {
    dispatch(setSelectedCustomer(customer));
    onCustomerSelect(customer);
  };

  const handleRemoveCustomer = () => {
    dispatch(resetCustomerSearch());
    setSearch("");
  };

  if (selectedCustomer) {
    return (
      <div className="customer-search-component">
        <div className="section-label">Selected Customer</div>
        <div className="selected-customer">
          <div className="customer-info">
            <span className="customer-name">
              {selectedCustomer.firstName} {selectedCustomer.lastName}
            </span>
            {selectedCustomer.company && (
              <span className="customer-company">
                ({selectedCustomer.company})
              </span>
            )}
          </div>
          <div className="remove-button" onClick={handleRemoveCustomer}>
            Remove
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="customer-search-component">
      <div className="section-label">Search Customer</div>
      <input
        type="text"
        className="search-input"
        placeholder="Search by customer name..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />

      {getCustomersStaxAPI.loading && (
        <div className="loading-container">
          <Oval color="#007AFF" height={24} width={24} />
        </div>
      )}

      {!getCustomersStaxAPI.loading && search.length > 0 && (
        <div className="customers-list">
          {customers.length === 0 ? (
            <div className="no-results">No customers found</div>
          ) : (
            customers.map((customer) => (
              <div
                key={customer.id}
                className="customer-item"
                onClick={() => handleCustomerSelect(customer)}
              >
                <span className="customer-name">
                  {customer.firstName} {customer.lastName}
                </span>
                {customer.company && (
                  <span className="customer-company">({customer.company})</span>
                )}
              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
};
